import { render, staticRenderFns } from "./PacklistItemsV5.vue?vue&type=template&id=a2a258d6&scoped=true"
import script from "./PacklistItemsV5.vue?vue&type=script&lang=js"
export * from "./PacklistItemsV5.vue?vue&type=script&lang=js"
import style0 from "./PacklistItemsV5.vue?vue&type=style&index=0&id=a2a258d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a258d6",
  null
  
)

export default component.exports